<template>
  <div>
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card header="Opciones de Consulta">
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="1"
              horizontal>
              <b-input-group v-if="seleccionCliente">
                <b-input-group-prepend 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !seleccion.cliente,
                                  'fa fa-remove': seleccion.cliente  }"></i>
                    <!-- <i class="fa fa-search"></i> -->
                  </b-input-group-text>
                </b-input-group-prepend>
                <!-- <b-input-group-prepend 
                    class="filter-search-icons" 
                    @click="cancelarSeleccionCliente">
                  <b-input-group-text>
                    <i class="fa fa-remove"></i>
                  </b-input-group-text>
                </b-input-group-prepend> -->
                <b-form-input 
                  :value="clienteSeleccionNombre"
                  readonly
                  type="text"/>
              </b-input-group>
              <b-form-input 
                :value="clienteNombre"
                readonly
                type="text"
                v-if="!seleccionCliente"/>
            </b-form-group>

            <b-form-group
              label="Desde"
              :label-cols="1"
              horizontal>
              <b-input-group>
                <b-form-input 
                  v-model= "seleccion.fechaDesde" 
                  type="date"
                  v-if="seleccionCliente">
                </b-form-input>
                <b-form-input 
                  :value= "fechaDesdeSeleccionada | fecha" 
                  readonly
                  type="text"
                  v-if="!seleccionCliente">
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Hasta"
              :label-cols="1"
              horizontal>
              <b-input-group>
                <b-form-input 
                  v-model= "seleccion.fechaHasta" 
                  type="date"
                  v-if="seleccionCliente">
                </b-form-input>
                <b-form-input 
                  :value= "fechaHastaSeleccionada | fecha" 
                  readonly
                  type="text"
                  v-if="!seleccionCliente">
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <div slot="footer">
              <b-button size="sm" variant="primary" class="footer-button" v-if="!seleccionCliente"
                @click.prevent="seleccionarOpciones">Seleccionar</b-button>
              <b-button size="sm" variant="primary" class="footer-button" v-if="seleccionCliente"
                @click.prevent="aceptarSeleccion">Aceptar</b-button>
              <b-button size="sm" variant="danger" class="footer-button" v-if="seleccionCliente"
                @click.prevent="cancelarSeleccion">Cancelar</b-button>
            </div>
          </b-card>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Cuenta Corriente de Clientes">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="cuentaCorriente" 
              :fields="cuentaCorrienteFields">
            <div slot="table-busy" class="text-center">
              <b-spinner variant="primary" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(debePesos)="data">
              {{ data.item.debePesos | moneda }}
            </template>
            <template v-slot:cell(haberPesos)="data">
              {{ data.item.haberPesos | moneda }}
            </template>
            <template v-slot:cell(saldoAcumuladoPesos)="data">
              {{ data.item.saldoAcumuladoPesos | moneda }}
            </template>
            <template v-slot:cell(debeDolares)="data">
              {{ data.item.debeDolares | moneda('usd') }}
            </template>
            <template v-slot:cell(haberDolares)="data">
              {{ data.item.haberDolares | moneda('usd') }}
            </template>
            <template v-slot:cell(saldoAcumuladoDolares)="data">
              {{ data.item.saldoAcumuladoDolares | moneda('usd') }}
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item
              @click.stop="exportXls">
            <i class="fa fa-file-excel-o"></i>Exportar Resumen</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue'
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import export_xls_cuenta_corriente from '../../mixins/export_xls_cuenta_corriente';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'cuentacorrienteclientes/getField',
  mutationType: 'cuentacorrienteclientes/updateField',
});

export default {
  name: 'CuentaCorrienteClientes',
  components: {
    appSearchCliente: SearchCliente,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
    export_xls_cuenta_corriente
  ],
  data: () => {
    return {
      cuentaCorrienteFields: [
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.'
        },
        { 
          key: 'comprobanteTipo',
          label: 'Tipo de Comp.' 
        },
        { 
          key: 'comprobanteNumero',
          label: 'Número' 
        },
        {
          key: 'debePesos',
          label: 'Debe - $',
          class: 'text-right'
        },
        {
          key: 'haberPesos',
          label: 'Haber - $',
          class: 'text-right'
        },
        {
          key: 'saldoAcumuladoPesos',
          label: 'Saldo - $',
          class: 'text-right'
        },
        {
          key: 'debeDolares',
          label: 'Debe - usd',
          class: 'text-right'
        },
        {
          key: 'haberDolares',
          label: 'Haber - usd',
          class: 'text-right'
        },
        {
          key: 'saldoAcumuladoDolares',
          label: 'Saldo - usd',
          class: 'text-right'
        },
      ],

      tableBusy: false,
      seleccionCliente: false,

      seleccion: {
        cliente: null,
        fechaDesde: '',
        fechaHasta: ''
      }
    }
  },
  computed: {
    ...mapFields([
      'cuentaCorriente',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'cliente',
    ]),
    clienteNombre: function() {
      return this.cliente ? this.cliente.nombre : '';
    },
    fechaDesdeSeleccionada: function() {
      return this.cliente ? this.fechaDesde : '1900-01-01';
    },
    fechaHastaSeleccionada: function() {
      return this.cliente ? this.fechaHasta : '1900-01-01';
    },
    clienteSeleccionNombre: function() {
      return this.seleccion.cliente ? this.seleccion.cliente.nombre : '';
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('cuentacorrienteclientes/getCuentaCorriente')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    seleccionarOpciones () {
      this.seleccion.cliente = this.cliente;
      this.seleccion.fechaDesde = this.fechaDesde;
      this.seleccion.fechaHasta = this.fechaHasta;
      this.seleccionCliente = true;
    },
    seleccionarCliente() {
      if (this.seleccion.cliente) {
        this.seleccion.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    cancelarSeleccionCliente() {
      this.seleccion.cliente = null;
    },
    clienteSeleccionado(item) {
      this.$refs.searchClienteModal.hide();
      this.seleccion.cliente = item;
    },
    aceptarSeleccion() {
      this.fechaDesde = this.seleccion.fechaDesde;
      this.fechaHasta = this.seleccion.fechaHasta;
      this.cliente = this.seleccion.cliente;
      this.seleccionCliente = false;
      this.paginaActual = 1;
      this.getItems();
    },
    cancelarSeleccion() {
      this.seleccionCliente = false;
    },
    exportXls () {
      this.showSpinner();
      this.$store.dispatch('cuentacorrienteclientes/getRptCuentaCorriente')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptCuentaCorriente = this.$store.getters['cuentacorrienteclientes/rptCuentaCorriente'];

          if (rptCuentaCorriente) {
            if (rptCuentaCorriente.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let params = {
              label: 'Cliente',
              nombreComercial: this.clienteNombre,
              fechaDesde: this.fechaDesdeSeleccionada,
              fechaHasta: this.fechaHastaSeleccionada,
              cuentaCorriente: rptCuentaCorriente
            }

            this.exportXLSRptCuentaCorriente(params);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    }

  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
